import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  IParamsPositions,
  PositionByIdResponse,
  PositionPostSchema,
  PositionPutSchema,
  PositionRest,
  PositionsResponse,
} from "~/entity/Positions";
import { paramsSerializer } from "~/shared/lib/paramsSerializer";

const positionsServiceMap = {
  getPositions: "/employee/positions",
};

export class PositionsService {
  static GET = {
    getPositions: (
      params: IParamsPositions,
    ): NetworkResponse<PositionsResponse> =>
      requestREST.get(positionsServiceMap.getPositions, {
        params,
        paramsSerializer: (params) => paramsSerializer(params),
      }),
    getPositionById: (
      instanceId: number | string,
    ): NetworkResponse<PositionByIdResponse> =>
      requestREST.get(`${positionsServiceMap.getPositions}/${instanceId}`),
  };

  static POST = {
    createPosition: (data: PositionPostSchema): NetworkResponse<PositionRest> =>
      requestREST.post(positionsServiceMap.getPositions, data),
  };

  static PUT = {
    putPosition: (
      instanceId: number | string,
      data: PositionPutSchema,
    ): NetworkResponse<PositionRest> =>
      requestREST.put(
        `${positionsServiceMap.getPositions}/${instanceId}`,
        data,
      ),
  };
}
